import { MapLayer } from "../models";

// Fond de carte : les tuiles OpenStreetMap standard, les mêmes que la carte du site
// (fleetlize.fr/map, `FL-WEB/src/Components/DashboardComponents/Map/AppMap.tsx`). Aucune clé.
//
// 2026-10-09 (demande de Julia) : remplace le fond CARTO, qui demandait une clé. L'ancienne
// définition est gardée telle quelle dans `cartoMapLayers.ts`, à côté de ce fichier. Elle n'est
// importée nulle part, donc ni elle ni sa clé ne partent dans la page construite. Pour y
// revenir : importer `./testData/cartoMapLayers` à la place de ce fichier dans `MapComponent.tsx`.
//
// Zoom : OpenStreetMap sert des tuiles jusqu'au niveau 19 (`maxNativeZoom`). L'application
// laisse zoomer jusqu'à 20 : au-delà de 19 les tuiles du niveau 19 sont agrandies au lieu de
// disparaître (sans `maxZoom`, une couche de tuiles s'arrête au niveau 18 et la carte devient
// vide plus près).
const mockMapLayers: MapLayer[] = [
  {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    baseLayerIsChecked: true,
    baseLayerName: "OpenStreetMap",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    maxNativeZoom: 19,
    maxZoom: 20,
  },
];

export default mockMapLayers;
